<template>
  <v-main
    v-on:drop.prevent
    class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
    style="height: 100%;"
  >

    <!--<v-checkbox active="true" class="pb-0 mb-0"
                v-on:change="changeExclude(item)"></v-checkbox>-->

    <v-layout
      row
      class="my-10"
    >
      <v-flex
        md12
        sm12
      >
        <div class="ml-6">
          <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Preview
            your data
          </div>

          <p class="text-right text__size-20">Total Address Records: {{ quantity }}</p>
          <v-card>
            <v-card-title class="layout__display-block">
              <div class="text__size-18 text__colour-grey text__style-bold layout__display-inline-block layout__position-top layout__padding__bottom-10px">
                Search Your Displayed Orders&nbsp;
              </div>

              <div class="layout__position-right layout__padding__bottom-10px">
                <el-input
                  autofocus
                  v-model="search"
                  class="inline-block search-field"
                  id="searchTextField"
                >
                </el-input>
                <!--<v-btn class="custom-btn data-search-btn inline-block"
                    :ripple="false" tile dark x-small depressed>
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>-->
              </div>

              <div
                v-show="search && filteredData.length"
                class="layout__justify-end"
              >
                <v-checkbox
                  v-model="selectDeselectFiltered"
                  class="px-2"
                  label="Select / Deselect Filtered"
                  v-on:change="selectDeselectFilteredData()"
                >
                </v-checkbox>
              </div>

              <!--<v-spacer></v-spacer>
              <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Your Displayed Orders"
                      single-line
                      hide-details
              ></v-text-field>-->
            </v-card-title>

            <v-layout
              column
              style="height: 46vh"
            >
              <v-flex
                md12
                style="overflow: auto"
              >
                <v-data-table
                  ref="datatable"
                  :headers="header_address"
                  :items="address"
                  :page.sync="page"
                  :items-per-page="items_per_page"
                  :hide-default-footer="true"
                  :search="search"
                  class="elevation-1"
                  item-key="id"
                  no-data-text="No address data"
                  @current-items="onCurrentItems"
                  @page-count="length_pagination = $event"
                >
                  <!--<template
                      v-slot:item.name="{ item }" >{{ getName(item) }}
                  </template>-->
                  <template v-slot:item.excludes="{ item }">
                    <v-checkbox
                      v-model="item.exclude"
                      class="pb-0 mb-0"
                      v-on:change="changeExclude(item)"
                    ></v-checkbox>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <!--<v-radio-group v-model="seed_data" column>-->
            <!--<v-radio-->
            <!--label="Add Branch seed"-->
            <!--&gt;</v-radio>-->
            <!--</v-radio-group>-->
          </v-card>

          <div class="layout__margin__top-20">
            <div class="layout__height-50px layout__border__bottom-light-teal layout__margin-30-0">
              <div class="layout__width-200px layout__margin__top-20 layout__margin__right-20 layout__float-left addressTo">
                <v-select
                  id="addressTo"
                  v-model="select"
                  :items="addressTo"
                  item-text="text"
                  item-value="value"
                  label="Address to"
                  @change="changedAddressTo"
                  width="200"
                  :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                  return-object
                ></v-select>
              </div>

              <!--<div class="layout__width-200px layout__float-left">
                  <v-checkbox v-model="personal_data"
                              class="float-left px-2"
                              label="Add Personal data"
                              required>
                  </v-checkbox>
              </div>-->

              <div class="layout__width-200px layout__margin__top-20 layout__margin__right-20 layout__float-left orderRecords">
                <v-select
                  :items="order_records"
                  item-text="text"
                  item-value="records"
                  label="Orders per page"
                  v-model="items_per_page"
                  @input="items_per_page = parseInt($event.records, 10)"
                  :menu-props="{contentClass: 'instant_marketing_dropdown_menu'}"
                  return-object
                ></v-select>
              </div>

              <div class="layout__width-280px layout__float-left">
                <v-checkbox
                  v-model="seed_data"
                  class="float-left px-2"
                  label="Add my branch to the mailing list"
                  required
                >
                </v-checkbox>
              </div>

              <div class="layout__width-200px layout__float-left">
                <v-checkbox
                  v-model="select_deselect"
                  class="float-left px-2"
                  label="Select / Deselect All"
                  v-on:change="selectDeselectAll()"
                >
                </v-checkbox>
              </div>

              <div class="layout__width-400px layout__float-right">
                <div class="float-right text-right">
                  <v-pagination
                    v-model="page"
                    class="my-4 float-right"
                    :length="length_pagination"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>

          <!--<v-row align="right" justify="right" class="py-4">-->
          <!--<v-btn @click="dataSelection()" class="float-right">
              <span class="text--teal px-10">Confirm data</span>
          </v-btn>-->
          <!--</v-row>-->

          <!--<div class="layout__position-relative layout__padding__bottom-20px">
              <div class="display-inline-block">
                  <i class="layout__position-absolute-top el-icon-info text__colour-red text__size-20"></i>
              </div>
              <div class="display-inline-block layout__margin__left-30 text__size-12">
                  Approximately 60% of our data has personalised contact information. If you would like<br>
                  to include this as part of your mailing, select the option above. For GDPR purposes we<br>
                  will only add personal data at the point of order, therefore this will not be visible during<br>
                  this process. Where we do not have personal data we will address the recipient based<br>
                  on your selection above. Further information can be found <a href="https://ravensworth.co.uk/terms-and-conditions/" target="new" class="here-link">here</a>.
              </div>
          </div>-->

          <div class="layout__padding__top-100px">
            <el-button
              class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
              v-on:click="goBack()"
            >Back
            </el-button>

            <el-button
              :disabled="loading || !quantity"
              class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right"
              v-on:click="dataSelection()"
            >Continue
            </el-button>
          </div>

          <v-overlay :value="loading">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </v-flex>

      <v-snackbar
        v-model="dataAccessFailure"
        color="error"
        :top="true"
        :timeout="5000"
      >
        Sorry there has been a problem accessing your data. Please try again.
        <v-btn
          dark
          text
          @click="dataAccessFailure = false"
        >
          Close
        </v-btn>
      </v-snackbar>

    </v-layout>
  </v-main>
</template>

<script>
import Router from '../../router.js';
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';

export default {
  name: 'InstantMarketingData',
  components: {},
  mixins: [axios],
  data: () => ({
    connection_params: {},
    order: {},
    dataProvider: '',
    search: '',
    orders_length: 5,
    //items_per_page: { records: -1, text: 'All' },
    items_per_page: 40,
    page: 1,
    personal_data: false,
    seed_data: true,
    select_deselect: false,
    selectDeselectFiltered: false,
    loading: false,
    filteredData: [],
    order_records: [
      10, 20, 30, 40, 50, 60, 80, 100, -1,
    ],
    order_records: [
      { records: 10, text: '10' },
      { records: 20, text: '20' },
      { records: 30, text: '30' },
      { records: 40, text: '40' },
      { records: 50, text: '50' },
      { records: 60, text: '60' },
      { records: 80, text: '80' },
      { records: 100, text: '100' },
      { records: -1, text: 'All' },
    ],
    dataAccessFailure: false,
    select: { text: 'The Homeowner', value: 'The Homeowner' },
    /*addressTo: [
        {text: 'Named Contact', value: ''},
        {text: 'The Occupier (unnamed only)', value: 'blanks_The Occupier'},
        {text: 'The Homeowner (unnamed only)', value: 'blanks_The Homeowner'},
        {text: 'The Legal Owner (unnamed only)', value: 'blanks_The Legal Owner'},
        {text: 'The Tenant (unnamed only)', value: 'blanks_The Tenant'},
        {text: 'The Occupier (all records)', value: 'The Occupier'},
        {text: 'The Homeowner (all records)', value: 'The Homeowner'},
        {text: 'The Legal Owner (all records)', value: 'The Legal Owner'},
        {text: 'The Tenant (all records)', value: 'The Tenant'},
    ],*/
    addressTo: [],
    /*header_address: [
        {text: 'Name', value: 'name'},
        {text: 'Address line 1', value: 'addr1'},
        {text: 'Address line 2', value: 'addr2'},
        {text: 'Address line 3', value: 'addr3'},
        {text: 'Address line 4', value: 'addr4'},
        {text: 'Address line 5', value: 'addr5'},
        {text: 'Address line 6', value: 'addr6'},
        {text: 'Postcode', value: 'postcode'},
        {text: 'Exclude Record', value: 'excludes'}
    ],*/
    header_address: [],
    address: [],
    excludes: [],
    names: [],
  }),
  computed: {
    quantity: {
      get() {
        var qty = this.address.length - this.excludes.length;

        if (this.seed_data) {
          qty += 1;
        }

        if (qty < 0) {
          return 0;
        } else {
          return qty;
        }
      },
      set(value) {
        this.value = value;
      },
    },
    length_pagination: {
      get() {
        if (this.orders_length === 0) {
          return 0;
        } else if (this.orders_length <= this.items_per_page) {
          return 1;
        } else if (this.orders_length > this.items_per_page) {
          return Math.ceil(this.orders_length / this.items_per_page);
        } else {
          return 0;
        }
      },
      set(value) {
        this.value = value;
      },
    },
  },
  async mounted() {
    this.loading = true;

    parent.postMessage('ScrollIntoView', '*');

    console.log('_seedData=' + window.sessionStorage.getItem('_seedData'));

    if (window.sessionStorage.getItem('_seedData') !== null) {
      this.seed_data = (window.sessionStorage.getItem('_seedData') == 'true');
    }

    //const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');
    const getOrderById = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

    console.log(getOrderById);

    Axios.get(getOrderById, this.returnHeaderUsingToken())
      .then(response => {
        console.log(response.data);

        this.order = response.data[0];
        console.log('this.order.dataUrl=' + this.order.dataUrl);
        console.log('this.order.dataExclusions=' + this.order.dataExclusions);

        if (this.order.dataExclusions !== null) {
          this.order.dataExclusions.split(',').forEach(dataExclusion => {
            this.excludes.push(dataExclusion);
          });
        }
        // window.sessionStorage.removeItem('imageUrl');

        this.connection_params = JSON.parse(window.sessionStorage.getItem('_connection_params'));

        if (this.connection_params.data_ref !== '') {
          // todo make the data call to pull the data from here

          this.getLeadHubDataAlreadyUploaded();

        } else {
          // var qs = window.sessionStorage.getItem('qs');

          if (this.order.dataUrl == 'String') {
            this.orders_length = this.address.length;

            for (let i = 0; i < this.address.length; i++) {
              this.names.push(this.address[i].name);
            }
          } else {
            // console.log('qs=' + qs);

            this.dataProvider = this.order.dataProvider;

            console.log('this.dataProvider ', this.dataProvider);

            if (this.dataProvider == 'Databook') {
              this.callDatabook();
            }

            if (this.dataProvider == 'Leadhub') {
              this.callLeadhub();
            }
          }
        }
      })
      .catch(() => {
        this.loading = false;
      });

    this.loading = false;
  },
  methods: {
    getLeadHubDataAlreadyUploaded() {
      this.loading = true;

      const getLeadHubUploadedData = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Partner/GetFilteredPropertyAddresses`;

      let getLeadhubUploadedDataBody = {};

      if (this.excludes) {
        getLeadhubUploadedDataBody = {
          'dataRef': this.connection_params.data_ref,
          'exclusions': this.excludes,
        };
      } else {
        getLeadhubUploadedDataBody = {
          'dataRef': this.connection_params.data_ref,
          'exclusions': [],
        };
      }

      console.log(getLeadhubUploadedDataBody);

      Axios.post(getLeadHubUploadedData, getLeadhubUploadedDataBody, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data.result);

          response.data.result.forEach(address => {

            let address_record = address.addressValues;
            this.address.push({
              id: address_record[12].value,
              name: address_record[0].value + ' ' + address_record[1].value + ' ' + address_record[2].value,
              addr1: address_record[4].value,
              addr2: address_record[5].value,
              addr3: address_record[6].value,
              addr4: address_record[7].value,
              addr5: address_record[8].value,
              addr6: address_record[9].value,
              postcode: address_record[10].value,
              exclude: false,
            });
            // this.names.push(record.people_text);
            this.names.push(address_record[7].value);
          });

          this.orders_length = this.address.length;
          this.loading = false;

        })
        .catch(error => {
          console.log(error);
          // if (error.response.status === 500) {
          // }
          event.stopPropagation();

          this.loading = false;
        });
    },
    navigate(path) {
      Router.push({
        path: '/' + path,
      });
    },
    goBack() {
      window.sessionStorage.removeItem('_addressTo');
      window.sessionStorage.removeItem('_personalData');
      window.sessionStorage.removeItem('_seedData');

      if (this.dataProvider == 'Databook') {
        this.navigate('select-data-databook');
      }

      if (this.dataProvider == 'Leadhub') {
        this.navigate('select-data-leadhub');
      }
    },
    async callDatabook() {
      console.log('callDatabook');

      this.loading = true;

      //var result = await this.checkDatabookToken();

      //if (result.result == 'error') {
      //    dataAccessFailure = true;
      //    this.loading = false;
      //} else {
      //let get_databook_data = `${process.env.VUE_APP_TKGATEWAY}/search?token=` + window.sessionStorage.getItem('_databook_auth_token') + this.order.dataUrl
      let get_databook_data = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=DatabookSearch&code=zpg1&customerRef=RAV02`;
      console.log('data_url=' + this.order.dataUrl);
      console.log('endpoint=' + get_databook_data);

      //Axios.get(get_databook_data, this.returnHeaderUsingToken())
      Axios({
        method: 'post',
        url: get_databook_data,
        crossdomain: true,
        data: this.order.dataUrl,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      })
        .then(response => {
          console.log('search success');
          console.log(response.data);

          var records = response.data.result.propertyAddresses,
            exclude;

          this.address = [];
          this.names = [];

          console.log('this.excludes: ' + this.excludes);

          /*this.select = {text: 'Named Contact', value: ''};

          this.addressTo = [
              {text: 'Named Contact', value: ''},
              {text: 'The Occupier (unnamed only)', value: 'blanks_The Occupier'},
              {text: 'The Homeowner (unnamed only)', value: 'blanks_The Homeowner'},
              {text: 'The Legal Owner (unnamed only)', value: 'blanks_The Legal Owner'},
              {text: 'The Tenant (unnamed only)', value: 'blanks_The Tenant'},
              {text: 'The Occupier (all records)', value: 'The Occupier'},
              {text: 'The Homeowner (all records)', value: 'The Homeowner'},
              {text: 'The Legal Owner (all records)', value: 'The Legal Owner'},
              {text: 'The Tenant (all records)', value: 'The Tenant'},
          ];*/

          this.select = { text: 'The Homeowner', value: 'The Homeowner' };

          this.addressTo = [
            { text: 'The Occupier', value: 'The Occupier' },
            { text: 'The Homeowner', value: 'The Homeowner' },
            { text: 'The Legal Owner', value: 'The Legal Owner' },
            { text: 'The Tenant', value: 'The Tenant' },
          ];

          this.header_address = [
            { text: 'Name', value: 'name' },
            { text: 'Address line 1', value: 'addr1' },
            { text: 'Address line 2', value: 'addr2' },
            { text: 'Address line 3', value: 'addr3' },
            { text: 'Address line 4', value: 'addr4' },
            { text: 'Address line 5', value: 'addr5' },
            { text: 'Address line 6', value: 'addr6' },
            { text: 'Postcode', value: 'postcode' },
            { text: 'Exclude Record', value: 'excludes' },
          ];

          for (let record, i = 0; record = records[i++];) {
            exclude = false;

            if (this.excludes.includes(record.address_urn)) {
              exclude = true;
            }

            var people_text = '';
            /*if (record.person.title !== "") {
                people_text += record.person.title;
            }
            if (record.person.forename !== "") {
                people_text += ' ' + record.person.forename;
            }
            if (record.person.surname !== "") {
                people_text += ' ' + record.person.surname;
            }

            if (people_text !== '') {
                people_text = '[Enhanced Name]';
            }*/

            this.address.push({
              id: record.address_urn,
              name: people_text,
              addr1: record.addr1,
              addr2: record.addr2,
              addr3: record.addr3,
              addr4: record.addr4,
              addr5: record.addr5,
              addr6: record.addr6,
              postcode: record.postcode,
              exclude: exclude,
            });
            this.names.push(people_text);
          }

          //this.address.sort(function(a, b) {
          //    return (a.addr1 > b.addr1) - (a.addr1 < b.addr1);
          //});

          this.address.sort(function (a, b) {
            var aA = a.addr1.replace(/[^a-zA-Z]/g, '');
            var bA = b.addr1.replace(/[^a-zA-Z]/g, '');
            if (aA === bA) {
              var aN = parseInt(a.addr1.replace(/[^0-9]/g, ''), 10);
              var bN = parseInt(b.addr1.replace(/[^0-9]/g, ''), 10);
              return aN === bN ? 0 : aN > bN ? 1 : -1;
            } else {
              return aA > bA ? 1 : -1;
            }
          });

          if (window.sessionStorage.getItem('_addressTo') !== null) {
            this.select = JSON.parse(window.sessionStorage.getItem('_addressTo'));
            //this.changedAddressTo(this.select);
          }

          console.log('this.select: ' + JSON.stringify(this.select));

          this.changedAddressTo(this.select);

          this.orders_length = this.address.length;
          this.loading = false;
        })
        .catch(error => {
          if (error.response) {
            //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
            console.log('auth failure: ' + error.response);
          }

          this.loading = false;
        });
      //}
    },
    async callLeadhub() {
      console.log('callLeadhub');

      this.loading = true;

      //let leadhubApiUrl = `${process.env.VUE_APP_LEADHUBAPI}`
      let leadhubApiUrl = `${process.env.VUE_APP_MARKETING_TOOLKIT}/api/1.1/zpgapi.asp?method=SpectreSearch&code=zpg1&customerRef=RAV02`;
      // local
      // let leadhubApiUrl = `http://test.tkv4.co.uk/api/1.1/zpgapi.asp?method=SpectreSearch&code=zpg1&customerRef=RAV02`;
      //var get_leadhub_data = `${process.env.VUE_APP_TKGATEWAY}` + this.order.dataUrl + '&expanded=true';
      //var get_leadhub_data = leadhubApiUrl + this.order.dataUrl;

      console.log('leadhubApiUrl: ' + leadhubApiUrl);
      console.log('this.order.dataUrl: ' + this.order.dataUrl);

      Axios({
        method: 'post',
        url: leadhubApiUrl,
        crossdomain: true,
        data: this.order.dataUrl,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      })
        .then(response => {
          console.log('search success');
          console.log(response.data);

          var records = response.data.attributes,
            exclude;

          this.address = [];
          this.names = [];

          console.log('this.excludes.length: ' + this.excludes.length);

          this.select = { text: 'The Occupier', value: 'blanks_The Occupier' };

          this.addressTo = [
            { text: 'The Occupier', value: 'blanks_The Occupier' },
            { text: 'The Homeowner', value: 'blanks_The Homeowner' },
            { text: 'The Legal Owner', value: 'blanks_The Legal Owner' },
          ];

          this.header_address = [
            { text: 'Street', value: 'street' },
            { text: 'Agent', value: 'agent' },
            { text: 'Exclude Record', value: 'excludes' },
          ];

          console.log('records.length: ' + records.length);

          for (var record, i = 0; record = records[i++];) {
            exclude = false;

            if (this.excludes.includes(record.attributes.id.toString())) {
              exclude = true;
            }

            this.address.push({
              id: record.attributes.id,
              street: record.attributes.street_name,
              agent: record.attributes.list_of_active_agencies[0],
              exclude: exclude,
            });
            this.names.push('');
          }

          if (window.sessionStorage.getItem('_addressTo') !== null) {
            this.select = JSON.parse(window.sessionStorage.getItem('_addressTo'));
            this.changedAddressTo(this.select);
          }

          console.log('this.select: ' + this.select);

          this.orders_length = this.address.length;

          console.log('this.address.length: ' + this.address.length);
          console.log('this.orders_length: ' + this.orders_length);
          console.log('this.length_pagination: ' + this.length_pagination);
          console.log('this.items_per_page: ' + this.items_per_page);


          this.loading = false;
        })
        .catch(error => {
          if (error.response) {
            //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
            console.log('search failure: ' + JSON.stringify(error.response));
          }

          this.loading = false;
        });
    },
    onCurrentItems() {
      if (! this.search) {
        return;
      }

      if (this.$refs.datatable) {
        // this is used to get ALL the searched items w/o the pagination limit
        this.filteredData = this.$refs.datatable.customFilterWithColumns(this.$refs.datatable.items, this.search);

        const hasAllExcludedItems = this.filteredData.filter(filteredDataItem => ! filteredDataItem.exclude).length === 0;

        if (hasAllExcludedItems) {
          this.selectDeselectFiltered = true;
        }
      }
    },
    changeExclude(item) {
      console.log('item: ', item);
      console.log('item.id: ' + item.id);

      if (item.exclude) {
        this.excludes.push(item.id);
      } else {
        this.selectDeselectFiltered = false;
        for (let i = 0; this.excludes.length > i; i++) {
          let exclude = this.excludes[i];
          if (exclude === item.id) {
            this.excludes.splice(i, 1);
          }
        }
      }

      console.log('this.excludes: ' + this.excludes);
    },
    changedAddressTo: function (addressTo) {
      console.log('addressee: ' + addressTo.value);
      console.log('this.select: ' + JSON.stringify(this.select));

      for (let i = 0; i < this.address.length; i++) {
        if (addressTo.value == 'blanks_The Occupier') {
          if (this.names[i] == '') {
            this.address[i].name = 'The Occupier';
          } else {
            this.address[i].name = this.names[i];
          }
        } else if (addressTo.value == 'blanks_The Homeowner') {
          if (this.names[i] == '') {
            this.address[i].name = 'The Homeowner';
          } else {
            this.address[i].name = this.names[i];
          }
        } else if (addressTo.value == 'blanks_The Legal Owner') {
          if (this.names[i] == '') {
            this.address[i].name = 'The Legal Owner';
          } else {
            this.address[i].name = this.names[i];
          }
        } else if (addressTo.value == 'blanks_The Tenant') {
          if (this.names[i] == '') {
            this.address[i].name = 'The Tenant';
          } else {
            this.address[i].name = this.names[i];
          }
        } else if (addressTo.value == 'The Occupier') {
          this.address[i].name = 'The Occupier';
        } else if (addressTo.value == 'The Homeowner') {
          this.address[i].name = 'The Homeowner';
        } else if (addressTo.value == 'The Legal Owner') {
          this.address[i].name = 'The Legal Owner';
        } else if (addressTo.value == 'The Tenant') {
          this.address[i].name = 'The Tenant';
        } else {
          this.address[i].name = this.names[i];
        }
      }
    },
    scrollIntoView() {
      parent.postMessage('ScrollIntoView', '*');
    },

    async dataSelection() {
      //for (let i = this.address.length - 1; i >= 0; i--) {
      //    if (this.address[i].excludes) {
      //        console.log(this.address[i].excludes);
      //        this.address.splice(i, 1);
      //    }
      //};

      this.loading = true;

      console.log(JSON.stringify(this.address));
      console.log(JSON.stringify(this.excludes));
      console.log(JSON.stringify(this.select.value));

      //window.sessionStorage.setItem('_data', JSON.stringify(this.address));
      // window.sessionStorage.setItem('_quantity', JSON.stringify(this.address.length));
      // window.sessionStorage.setItem('_excludes', JSON.stringify(this.excludes));
      window.sessionStorage.setItem('_addressTo', JSON.stringify(this.select));
      window.sessionStorage.setItem('_personalData', this.personal_data);
      window.sessionStorage.setItem('_seedData', this.seed_data);

      console.log(this.quantity);

      //const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + this.order.id;
      const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + window.sessionStorage.getItem('_order_id');

      const update_body = [
        {
          'value': this.quantity,
          'path': '/printJobSpec/quantity',
          'op': 'replace',
        },
      ];

      update_body.push({
        'value': this.select.value,
        'path': '/addressTo',
        'op': 'replace',
      });

      if (this.excludes.length > 0) {
        update_body.push({
          'value': this.excludes.join(','),
          'path': '/dataExclusions',
          'op': 'replace',
        });
      }

      if (this.seed_data && this.order.dataUrl.indexOf('&seed=1') < 0) {
        update_body.push({
          'value': this.order.dataUrl + '&seed=1',
          'path': '/dataUrl',
          'op': 'replace',
        });
      }

      if (! this.seed_data && this.order.dataUrl.indexOf('&seed=1') >= 0) {
        update_body.push({
          'value': this.order.dataUrl.replace('&seed=1', ''),
          'path': '/dataUrl',
          'op': 'replace',
        });
      }

      console.log(patch_order);
      console.log(update_body);

      Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
        .then(response => {
          console.log(response.data);

          this.loading = false;

          this.navigate('select-design-type');
        })
        .catch(error => {
          console.log(error);

          this.loading = false;
        });
    },
    selectDeselectFilteredData() {
      this.address = this.address.map((addressItem) => {
        this.filteredData.forEach((filteredDataItem) => {
          if (filteredDataItem.id === addressItem.id) {
            addressItem.exclude = this.selectDeselectFiltered;

            if (this.selectDeselectFiltered && ! this.excludes.includes(filteredDataItem.id)) {
              this.excludes.push(filteredDataItem.id);
            } else if (! this.selectDeselectFiltered && this.excludes.includes(filteredDataItem.id)) {
              this.excludes = this.excludes.filter(exclude => exclude !== filteredDataItem.id);
            }
          }
        });

        return addressItem;
      });
    },
    selectDeselectAll() {
      console.log('selectDeselectAll: this.select_deselect=' + this.select_deselect);
      this.excludes = [];

      if (! this.select_deselect) {
        this.selectDeselectFiltered = false;
      }

      for (let item, i = 0; item = this.address[i++];) {
        item.exclude = this.select_deselect;

        if (this.select_deselect) {
          this.excludes.push(item.id);
        }
      }
    },
  },
};
</script>
